import { render, staticRenderFns } from "./IsverenForm.vue?vue&type=template&id=39483f2e"
import script from "./IsverenForm.vue?vue&type=script&lang=ts"
export * from "./IsverenForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports